import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Kpi, KpiKeys, KpiTimeCycleChartData } from '@models';

import { KpiExpandedViewComponent } from '../kpi-expanded-view/kpi-expanded-view.component';
interface MilestoneStatusSummaryItem {
  label: string;
  value: number;
}
const DEFAULT_TIME_CYCLE_CHART_DATA: KpiTimeCycleChartData = {
  identifier: 'timeCycleChart',
  title: 'Average cycle time',
  tooltipText:
    'Cycle time is the elapsed time from the first milestone’s start to the second milestone’s completion.',
  labels: [],
  offset: [],
  timeWeeks: [],
  category: [],
  cycleCount: 0
};

@Component({
  selector: 'portfolio-kpi-side-panel',
  templateUrl: './portfolio-kpi-side-panel.component.html',
  styleUrl: './portfolio-kpi-side-panel.component.scss'
})
export class PortfolioKpiSidePanelComponent {
  private dialog = inject(MatDialog);

  @Input() selectedKpi?: { key: KpiKeys; kpi: Kpi };
  @Input() isHeaderLoading = false;
  @Input() isCycleLoading = false;
  @Input() isSummaryLoading = false;
  @Input() columnTitleMappings: Record<string, string> = {};
  @Input() portfolioKpiSecondaryValue = '--';
  @Input() portfolioKpiDisplayValue = '--';
  @Input() portfolioExpandedPanelExpanded = false;
  @Input() portfolioExpandedStudiesText = '--';
  @Input() placeholderMilestoneRows: MatTableDataSource<any> = new MatTableDataSource<any>();
  @Input() milestoneStatusSummaryData: MilestoneStatusSummaryItem[] = [];
  @Input() timeCycleChartData: KpiTimeCycleChartData = DEFAULT_TIME_CYCLE_CHART_DATA;
  @Input() kpiFiltersApplied: Record<string, string[]> = {};
  @Input() totalKpiFiltersApplied = 0;

  @Output() expandedCollapse = new EventEmitter<void>();
  @Output() expandedCloseAll = new EventEmitter<void>();
  @Output() summaryStatusFilterToggle = new EventEmitter<string>();
  @Output() kpiRemoveFilter = new EventEmitter<{ field: string; value: string }>();
  @Output() kpiClearAllFilters = new EventEmitter<void>();

  openExpandedChart(title: string, chartCardType: 'cycle' | 'summary'): void {
    this.dialog.open(KpiExpandedViewComponent, {
      data: {
        title,
        type: 'chart',
        chartCardType,
        isLoading: chartCardType === 'cycle' ? this.isCycleLoading : this.isSummaryLoading,
        timeCycleChartData: chartCardType === 'cycle' ? this.timeCycleChartData : undefined,
        columnTitleMappings: this.columnTitleMappings,
        kpiFiltersApplied: this.kpiFiltersApplied,
        totalKpiFiltersApplied: this.totalKpiFiltersApplied,
        getMilestoneStatusSummaryData: () => this.milestoneStatusSummaryData,
        getTimeCycleChartData: () => this.timeCycleChartData,
        getIsLoading: () =>
          chartCardType === 'cycle' ? this.isCycleLoading : this.isSummaryLoading,
        getKpiFiltersApplied: () => this.kpiFiltersApplied,
        getTotalKpiFiltersApplied: () => this.totalKpiFiltersApplied,
        onSummaryStatusClick: (status: string) => this.summaryStatusFilterToggle.emit(status),
        onKpiRemoveFilter: (payload: { field: string; value: string }) =>
          this.kpiRemoveFilter.emit(payload),
        onKpiClearAllFilters: () => this.kpiClearAllFilters.emit(),
        milestoneStatusSummaryData:
          chartCardType === 'summary' ? this.milestoneStatusSummaryData : []
      },
      panelClass: 'fullscreen-dialog',
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh'
    });
  }
}
